import { render, staticRenderFns } from "./modalReestablish.vue?vue&type=template&id=52a30e4e&"
import script from "./modalReestablish.vue?vue&type=script&lang=js&"
export * from "./modalReestablish.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports